import { Component, Vue, Prop } from "vue-property-decorator";
import template from "./rim-repair-status.template.vue";
import { IWorkOrderCard, Callback } from "@/interfaces";
import { MEMO_RULES } from "@/validators";
import { SetWorkOrderStatus } from "@/api";
import { Action } from "vuex-class";

@Component({
  mixins: [template]
})
export default class RimRepairStatusComponent extends Vue {
  @Prop({ required: true }) workOrder!: IWorkOrderCard;
  @Prop({ required: true }) type!: string;
  @Action("setSnackbar", { namespace: "AppModule" })
  public setSnackbarAction!: Callback;
  public memo = "";
  public completed = false;
  public memoRules = MEMO_RULES;
  public buttonLoading = false;
  public valid = false;

  mounted() {
    this.completed = this.workOrder.IsCompleted;
  }

  close() {
    this.$emit("close");
  }

  async validate() {
    try {
      if ((this.$refs.statusForm as HTMLFormElement).validate()) {
        this.buttonLoading = true;
        const resp = await SetWorkOrderStatus({
          WorkOrderID: this.workOrder.RecordID,
          Memo: this.memo,
          IsCompleted: this.completed
        });
        this.buttonLoading = false;
        if (resp.Ok) {
          this.setSnackbarAction({
            message: `Work order changed successfully`,
            status: "success"
          });
          this.$emit("close-succes");
        }
      }
    } catch (err) {
      //
    }
  }
}
